/**
 * Work Page - Tab switch + tag filter
 */
$(document).ready(function () {
	var $tabs = $(".work-projects__tab");
	var $cards = $(".work-projects__card");
	var $section = $(".work-projects");
	var $allTagLists = $(".work-hero__tags");

	// --- Initial filter on page load ---
	var initialTab = $section.attr("data-active-tab");
	if (initialTab) {
		$cards.each(function () {
			if ($(this).data("category") !== initialTab) {
				$(this).addClass("is-hidden");
			}
		});
	}

	// --- Tab click ---
	$tabs.on("click", function () {
		var tab = $(this).data("tab");

		// Update active tab
		$tabs.removeClass("is-active");
		$(this).addClass("is-active");
		$section.attr("data-active-tab", tab);

		// Switch tags list
		$allTagLists.addClass("is-hidden");
		$allTagLists.filter('[data-for-tab="' + tab + '"]').removeClass("is-hidden");

		// Reset tag active state
		$allTagLists.find(".work-hero__tag").removeClass("is-active");

		// Show only cards for this tab
		$cards.each(function () {
			if ($(this).data("category") === tab) {
				$(this).removeClass("is-hidden");
			} else {
				$(this).addClass("is-hidden");
			}
		});
	});

	// --- Tag click (filter within current tab) ---
	$(document).on("click", ".work-hero__tag", function () {
		var $this = $(this);
		var filter = $this.data("filter");
		var currentTab = $section.attr("data-active-tab");
		var $currentTags = $allTagLists.filter('[data-for-tab="' + currentTab + '"]').find(".work-hero__tag");

		// Toggle: click same tag = deselect (show all in tab)
		if ($this.hasClass("is-active")) {
			$this.removeClass("is-active");
			$cards.each(function () {
				if ($(this).data("category") === currentTab) {
					$(this).removeClass("is-hidden");
				}
			});
			return;
		}

		// Set active tag
		$currentTags.removeClass("is-active");
		$this.addClass("is-active");

		// Filter cards by tag within current tab
		$cards.each(function () {
			var $card = $(this);
			var cardTags = String($card.data("tag")).split(" ");
			if ($card.data("category") === currentTab && cardTags.indexOf(filter) !== -1) {
				$card.removeClass("is-hidden");
			} else {
				$card.addClass("is-hidden");
			}
		});
	});
});
